export const ERROR_NOTIFICATION = 'ERROR_NOTIFICATION';

export const SUCCESS_NOTIFICATION = 'SUCCESS_NOTIFICATION';